import PropTypes from 'prop-types';

import styles from './ProcedureLayout.module.scss';

const ProcedureLayout = ({ children }) => (
  <section className={styles.procedureLayout}>{children}</section>
);

ProcedureLayout.propTypes = {
  children: PropTypes.node,
};

ProcedureLayout.defaultProps = {
  children: <div />,
};

export default ProcedureLayout;
